import { render, staticRenderFns } from "./DotCmsLink.vue?vue&type=template&id=363fdaed&"
import script from "./DotCmsLink.vue?vue&type=script&lang=js&"
export * from "./DotCmsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports